module.exports = __webpack_public_path__ + "cb4887946d1881b617f3eccf7d38b865.png";